import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from '@/app/App';
import { ToastHost } from '@/components/ToastHost';
import { initErrorTracking } from '@/services/ErrorTrackingService';
import { requestPersistentStorage } from '@/db/persistentStorage';
// Inter, self-hosted. Imported before theme.css so the @font-face rules are in
// place before anything that uses them.
//
// `wght` is the weight-only variable axis — one file covering 100–900, rather
// than a file per weight. The package ships a @font-face per unicode subset,
// each with its own `unicode-range`, so an English till downloads only the
// latin file (~48KB) and never fetches the cyrillic/greek/vietnamese ones.
//
// Self-hosted rather than a CDN on purpose: this is an offline-first POS, and
// a webfont that needs the network would fall back to a system face exactly
// when the till has no connection.
import '@fontsource-variable/inter/wght.css';
import './app/theme.css';

initErrorTracking();

// Ask before the first render: the till's database holds unsynced sales and the
// invoice sequence, neither of which survives an eviction. Fire-and-forget —
// the answer changes nothing about how the app boots.
void requestPersistentStorage();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
    <ToastHost />
  </React.StrictMode>,
);
